import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { InputMask } from "@react-input/mask";
import "./style.css";

const DeviceDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [deviceID, setDeviceID] = useState("");
	const [organization, setOrganization] = useState("");
	const [person, setPerson] = useState("");
	const [status, setStatus] = useState("");
	const [brand, setBrand] = useState("");
	const [purchaseDate, setPurchaseDate] = useState("");
	const [installationDate, setInstallationDate] = useState("");
	const [location, setLocation] = useState("");
	const [room, setRoom] = useState("");
	const [floor, setFloor] = useState("");
	const [roomType, setRoomType] = useState("");
	const [roomName, setRoomName] = useState("");
	const [smsPhone, setSmsPhone] = useState("");
	const [suiteName, setSuiteName] = useState("");
	const [deviceNote, setDeviceNote] = useState("");
	const [isDemo, setIsDemo] = useState(false);

	// For room count and floor count
	const [orgName, setOrgName] = useState([]);
	const [usernames, setUsernames] = useState([]);
	const [floorCount, setFloorCount] = useState(0);
	const [roomCount, setRoomCount] = useState(0);

	const getDevice = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/devices/${id}`);
			if (response.ok) {
				const deviceData = await response.json();
				// Verileri state'lere yükle
				setDeviceID(deviceData.deviceID || "");
				setOrganization(deviceData.organization || "");
				setPerson(deviceData.person || "");
				setStatus(deviceData.status || "");
				setBrand(deviceData.brand || "");
				setPurchaseDate(deviceData.purchaseDate || "");
				setInstallationDate(deviceData.installationDate || "");
				setLocation(deviceData.location || "");
				setRoom(deviceData.room || "");
				setFloor(deviceData.floor || "");
				setRoomType(deviceData.roomType || "");
				setRoomName(deviceData.roomName || "");
				setSmsPhone(deviceData.smsPhone || "");
				setSuiteName(deviceData.suiteName || "");
				setDeviceNote(deviceData.deviceNote || "");
				setIsDemo(deviceData.isDemo || false);
			} else {
				alert("Cihaz bulunamadı");
				navigate("/devices");
			}
		} catch (error) {
			console.error("Cihaz verileri getirilirken bir hata oluştu:", error);
			alert("Cihaz verileri yüklenirken bir hata oluştu");
		} finally {
			setLoading(false);
		}
	};

	const getUsernames = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/usernames`);
			const usernamesData = await response.json();
			setUsernames(usernamesData);
		} catch (error) {
			console.error("Kullanıcı verileri getirilirken bir hata oluştu:", error);
		}
	};

	const getOrganisations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const organisationName = await response.json();
			setOrgName(organisationName);
		} catch (error) {
			console.error("Veri getirilirken bir hata oluştu:", error);
		}
	};

	useEffect(() => {
		if (id) {
			getDevice();
			getUsernames();
			getOrganisations();
		}
	}, [id]);

	useEffect(() => {
		const selectedOrg = orgName?.find(
			(org) => org.organisationName === organization
		);
		if (selectedOrg) {
			setFloorCount(parseInt(selectedOrg.organisationFloors) || 0);
			setRoomCount(parseInt(selectedOrg.organisationRooms) || 0);
		}
	}, [organization, orgName]);

	const handleUpdate = async (e) => {
		e.preventDefault();

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch("https://app.vivasmartcare.com/api/device-update", {
				method: "PUT",
				body: JSON.stringify({
					id,
					deviceID,
					organization,
					person,
					status,
					brand,
					purchaseDate,
					installationDate,
					location,
					floor,
					room,
					roomName,
					smsPhone,
					suiteName,
					deviceNote,
					roomType,
					isDemo,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Cihaz Güncellendi");
				navigate("/devices");
			} else {
				alert("Cihaz güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			alert("Cihaz güncellenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	if (loading) {
		return (
			<Layout>
				<div
					className="user-modal-inputs"
					style={{ textAlign: "center", padding: "50px" }}
				>
					<Spinner animation="border" variant="primary" />
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className="user-modal-inputs">
				<Form onSubmit={handleUpdate}>
					<Form.Group>
						<label className="mb-2">Cihaz ID:</label>
						<Form.Control
							type="text"
							placeholder="Cihaz ID Giriniz"
							value={deviceID}
							required
							onChange={(e) => setDeviceID(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum:</label>
						<Form.Select
							value={organization}
							onChange={(e) => setOrganization(e.target.value)}
							required
						>
							<option value="">Kurum Seç</option>
							{orgName?.map((org, index) => (
								<option value={org.organisationName} key={index}>
									{org.organisationName}
								</option>
							))}
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Cihaz Türü:</label>
						<Form.Select
							value={brand}
							onChange={(e) => setBrand(e.target.value)}
							required
						>
							<option value="">Cihaz Türü Seçiniz:</option>
							<option value="Vayyar">Düşme Cihazı</option>
							<option value="Viva02P">Yatak Sensörü</option>
							<option value="Viva03D">Hobacare</option>
							<option value="Vivistar">Vivistar</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kullanıcı:</label>
						<Form.Select
							value={person}
							onChange={(e) => setPerson(e.target.value)}
							required
						>
							<option value="">Kullanıcı Seçiniz:</option>
							{usernames?.map((username, index) => (
								<option value={username.userName} key={index}>
									{username.userName}
								</option>
							))}
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Cihaz Durumu:</label>
						<Form.Select
							value={status}
							onChange={(e) => setStatus(e.target.value)}
							required
						>
							<option value="">Cihaz Durumu</option>
							<option value="Aktif">Aktif</option>
							<option value="Pasif">Pasif</option>
							<option value="Teknik Arıza">Teknik Arıza</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Satın Alma Tarihi:</label>
						<Form.Control
							type="date"
							value={purchaseDate}
							required
							onChange={(e) => setPurchaseDate(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurulum Tarihi:</label>
						<Form.Control
							type="date"
							value={installationDate}
							required
							onChange={(e) => setInstallationDate(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Konum:</label>
						<Form.Select
							value={location}
							onChange={(e) => setLocation(e.target.value)}
							required
						>
							<option value="">Konum</option>
							<option value="Kurum">Kurum</option>
							<option value="Ev">Ev</option>
							<option value="Depo">Depo</option>
							<option value="Bakım">Bakım</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Bulunduğu Kat:</label>
						<Form.Select
							required
							value={floor}
							onChange={(e) => setFloor(e.target.value)}
						>
							<option value="">Kat Seçiniz:</option>
							{floorCount &&
								floorCount > 0 &&
								[...Array(floorCount).keys()].map((floorCount, index) => (
									<option key={index + 1} value={index + 1}>
										{index + 1}. Kat
									</option>
								))}
						</Form.Select>
					</Form.Group>
					{location === "Kurum" && (
						<Form.Group>
							<label className="mb-2">Süit İsmi:</label>
							<Form.Control
								type="text"
								placeholder="Süit Adı Giriniz:"
								required
								value={suiteName}
								onChange={(e) => setSuiteName(e.target.value)}
							/>
						</Form.Group>
					)}
					<Form.Group>
						<label className="mb-2">Oda Tipi/Oda:</label>
						{location === "Kurum" || location === "Ev" ? (
							<Form.Select
								value={roomType}
								onChange={(e) => setRoomType(e.target.value)}
								required
							>
								<option value="">Oda Tipi Seçiniz:</option>
								<option value="Banyo">Banyo</option>
								<option value="Yatak Odası">Yatak Odası</option>
								<option value="Aile Odası">Aile Odası</option>
								<option value="Koridor">Koridor</option>
								<option value="Mutfak">Mutfak</option>
								<option value="Yemek Odası">Yemek Odası</option>
								<option value="Oturma Odası">Oturma Odası</option>
								<option value="Diğer">Diğer</option>
							</Form.Select>
						) : (
							<Form.Select
								required
								value={room}
								onChange={(e) => setRoom(e.target.value)}
							>
								<option value="">Oda Seçiniz:</option>
								{roomCount &&
									roomCount > 0 &&
									[...Array(roomCount).keys()].map((roomCount, index) => (
										<option key={index + 1} value={index + 1}>
											{index + 1}. Oda
										</option>
									))}
							</Form.Select>
						)}
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Oda İsmi:</label>
						<Form.Control
							type="text"
							placeholder="Odaya İsim Giriniz"
							required
							value={roomName}
							onChange={(e) => setRoomName(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Bildirimler İçin Numara:</label>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							value={smsPhone}
							showMask
							onChange={(e) => setSmsPhone(e.target.value)}
							className="form-control"
							required
						/>
					</Form.Group>
					<Form.Group className="full-width">
						<label className="mb-2">Cihaz Notları:</label>
						<Form.Control
							as="textarea"
							placeholder="Cihaz ile İlgili Notları Giriniz"
							value={deviceNote}
							onChange={(e) => setDeviceNote(e.target.value)}
						/>
					</Form.Group>
					<Form.Group className="full-width">
						<Form.Check
							type="switch"
							id="custom-switch"
							label="Bu bir demo cihazıdır"
							checked={isDemo}
							onChange={(e) => setIsDemo(e.target.checked)}
						/>
					</Form.Group>
					<div className="button-wrapper">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/devices")}
						>
							İptal
						</Button>
						<Button variant="primary" type="submit" disabled={btnDisabled}>
							{showSpinner ? (
								<>
									<Spinner
										animation="border"
										size="sm"
										style={{ marginRight: "8px" }}
									/>
									Güncelleniyor...
								</>
							) : (
								"Güncelle"
							)}
						</Button>
					</div>
				</Form>
			</div>
		</Layout>
	);
};

export default DeviceDetail;
